export const GOOGLE_MAPS_API_KEY = 'AIzaSyAk7S1jjrZl2yN6c8a0LMtQPbzMgGufago';